<template>
   <div class="app flex-row align-items-center justify-content-center">
      <v-card
         class="mx-4" 
         width="800px"
         min-width="350px"
      >
         <v-card-title class="p-4" height="200px">
            <h1>{{title}}</h1>
            <v-spacer></v-spacer>
            <ddoCart :cart="cartx" :callbacks="callbacks" :options="options">
            </ddoCart>
         </v-card-title>

         <v-card-text>
            
            <Catalog :callbacks="callbacks" :options="options"/>

            <v-spacer></v-spacer>

            <span v-html="currentItem.presentation">
            </span>

         </v-card-text>

      </v-card>
   </div>
</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoCart from '@/components/ddoCart.vue';
import Catalog from '@/views/catalog/Catalog.vue';


export default {
   name: 'Checkout',

   components: {
      i18n,
      ddoCart,
      Catalog,
   },

   data: () => {
      return {
        callbacks: {},
        options: [],
        cart: [],
        currentItem: {
           presentation: "",
        },
        title: null,

        cartKeys: ['_pk'],
        cartx: [],
      }
   },

   created () {
      this.callbacks.onchange   = this.change_plan;
      this.callbacks.oninit     = this.init;
      this.callbacks.oncart     = this.add_to_cart;
      this.callbacks.cart_clear = this.clear_cart;
      this.options = [ 'no_minus', 'no_plus', 'no_quantity', 'no_cancel', 'reset', 'with_addons' ];

      this.cartx = this.$store.getters.cart;
      this.$store.commit("cartKeys",this.cartKeys);
   },

   methods: {

      init(title) {
         this.title = title;
      },

      clear_cart() {
         this.cartx = [];
         this.$store.commit("empty");
      },

      add_to_cart(item,options=[]) {
         let line = { id: item._pk, _pk: item._pk, product: item.pro_name_plan, quantity: 1, price: item.pro_price_plan, addons: [] };
         if ( options.indexOf('reset') ) {
            this.cartx = [];
            this.$store.commit("empty");
         }
         for ( var i=0;i<item.pro_addons.length;i++) {
            if ( item.pro_addons[i].pro_addon_checked==true ) {
               line.addons.push({ _pk: item.pro_addons[i]._pk, checked: item.pro_addons[i].pro_addon_checked, product: item.pro_addons[i].pro_name, price: item.pro_addons[i].pro_price });
            }
         }
         console.log('Checkout::cart, line='+JSON.stringify(line));
         this.cartx.push(line);
         this.$store.commit("addItem",line);
         console.log('add_to_cart, cartx='+JSON.stringify(this.$store.getters.cart))
      },

      change_plan(item) {
         if ( item.pro_html_content_product ) {
            let presentation = item.pro_html_content_product;
            if ( item.pro_html_content_plan ) {
               presentation = presentation.replace('$pro_html_content_plan$', item.pro_html_content_plan );
            } else {
               presentation = presentation.replace('$pro_html_content_plan$', '' );
            }
            this.currentItem.presentation = presentation;
         }
      },

   },

}
</script>
